/* global axios */
import ApiClient from '../ApiClient';

class WgptMcpServersAPI extends ApiClient {
  constructor() {
    super('mcp_servers', { accountScoped: true, wgpt: true });
  }

  regenerateToken(id) {
    return axios.post(`${this.url}/${id}/regenerate_token`);
  }

  addTool(id, data) {
    return axios.post(`${this.url}/${id}/add_tool`, data);
  }

  updateTool(id, toolId, data) {
    return axios.patch(`${this.url}/${id}/update_tool/${toolId}`, data);
  }

  deleteTool(id, toolId) {
    return axios.delete(`${this.url}/${id}/delete_tool/${toolId}`);
  }

  cloneTool(id, toolId) {
    return axios.post(`${this.url}/${id}/clone_tool/${toolId}`);
  }

  testTool(id, data) {
    return axios.post(`${this.url}/${id}/test`, data);
  }

  getExecutions(id, params = {}) {
    return axios.get(`${this.url}/${id}/executions`, { params });
  }

  clone(id) {
    return axios.post(`${this.url}/${id}/clone`);
  }

  async export(id) {
    const { data, headers } = await axios.get(`${this.url}/${id}/export`, {
      responseType: 'blob',
    });

    let filename = 'mcp_server_export.wgpt';
    const contentDisposition = headers['content-disposition'];
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(
        /filename\*=UTF-8''([^;]+)/i
      );
      if (filenameMatch) {
        filename = decodeURIComponent(filenameMatch[1]);
      }
    }

    const file = new File([data], filename, { type: 'application/zip' });
    return { data: file };
  }

  import(data) {
    return axios.post(`${this.url}/import`, data);
  }
}

export default WgptMcpServersAPI;
